import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { useColorStore } from '@/store/colorStore';

interface ProgressCardProps {
  title: string;
  value: number;
  peakHour: string;
  // Vehicles detected in that same peak hour - not today's running total.
  peakVolume: number;
  className?: string;
}

const ProgressCard = ({ title, value, peakHour, peakVolume, className }: ProgressCardProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();

  const percentage = Math.max(0, Math.min(100, value));

  const progressColor =
    percentage <= 50
      ? NEWCOLOR.greenPrimary
      : percentage <= 70
        ? NEWCOLOR.warning
        : NEWCOLOR.danger;

  return (
    <div
      className={cn(
        'flex flex-col w-full gap-2 rounded-[12px] border p-3 shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] dark:bg-[#F3F6FE]/10',
        className
      )}
    >
      <span className="title2">{title}</span>

      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-white/10">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${percentage}%`,
            backgroundColor: progressColor,
          }}
        />
      </div>

      <div className=" h4mediumVW" style={{ color: progressColor }}>
        {percentage}%
      </div>

      <div className="flex gap-3">
        <div className="flex flex-col gap-2 flex-1">
          <span className="title2 uppercase">{t('traffic>master>peak hour')}</span>

          <span className="h4mediumVW" style={{ color: NEWCOLOR.bluePrimary }}>
            {peakHour}
          </span>
        </div>

        <div className="flex flex-col gap-2 flex-1">
          <span className="title2 uppercase">{t('traffic>master>peak hour volume')}</span>

          <span className="h4mediumVW" style={{ color: NEWCOLOR.bluePrimary }}>
            {peakVolume}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressCard;
